import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userRole: '',
  resultObject: {},
  locationState: {},
  clickedCards: {},
};
const utilitiesSlice = createSlice({
  name: 'utilities',
  initialState,
  reducers: {
    filterByMonth: (state, action) => {
      return { monthlyData: action.payload };
    },
    updateUserType: (state, action) => {
      return { userRole: action.payload };
    },
    updatePayload: (state, action) => {
      return { payloadUpdater: Date.now() };
    },
    shareResultData: (state, { payload }) => {
      state.resultObject = payload;
    },
    shareRouteData: (state, { payload }) => {
      state.locationState = payload;
    },
    setClickedCardIndex: (state, action) => {
      const { route, index } = action.payload;
      if (['dashboard', 'plots', 'plants', 'plantation'].includes(route))
        state.clickedCards[route] = index;
      else state.clickedCards = {};
    },
  },
});

const { reducer, actions } = utilitiesSlice;
// export const selectClickedCardIndex = (state) => state.utilities.clickedCards;
export const {
  filterByMonth,
  updateUserType,
  updatePayload,
  shareResultData,
  shareRouteData,
  setClickedCardIndex,
} = actions;
export default reducer;
